'use strict';

angular.module('formonlineApp')
    .controller('DeclarisLRController', function ($scope, $log, $state, $stateParams, $translate, $sce, StringUtil, ObjectUtils,
                                                  PrintUtil, ContextFiscalService, BaremeService, DeclarationLRService,
                                                  WhitelistService, LocaliteService, $window, $timeout, FrontendlogService,
                                                  ErrorUtil, ValidationUtil, Language, ListUtils, ERROR_PREFIX, IframeService, $http) {
        var vm = $scope;

        var localStorageKey = 'formOnline.declaris';

        var cantonFRCode = 'FR';

        vm.baremes = [];
        vm.baremesSansRevenuDeterminant = [];
        vm.baremesEnfantObligatoire = [];
        vm.baremesAvecEnfants = [];

        vm.localites = [];

        vm.formHelper = {};
        vm.formHelper.step = 1;
        vm.formHelper.fileUploaded = false;
        vm.formHelper.contexteFiscale = null;
        vm.formHelper.anneesFiscales = null;
        vm.formHelper.authorized = false;
        vm.formHelper.fileUploadError = null;
        vm.formHelper.saveHeader = false;
        vm.formHelper.saved = $window.localStorage.getItem(localStorageKey);
        vm.formHelper.dateDemande = new Date();
        vm.formHelper.errorMsg = null;
        vm.formHelper.showValidationMsg = false;

        vm.errors = {};
        vm.warnings = {};

        vm.ongoingRequest = false;

        vm.declaration = {
            anneeFiscale: null,
            typeDeclarationIs: 'FORM',
            langue: 'fr'
        };

        vm.checkAuthorization = function () {
            if (vm.declaration.ndc && vm.declaration.ndc !== '' && vm.declaration.codeSecurite && vm.declaration.codeSecurite !== '' && vm.declaration.anneeFiscale && vm.declaration.anneeFiscale !== '') {
                WhitelistService.check(vm.declaration.ndc.replace(/\.|\/|_/g, ''), vm.declaration.anneeFiscale, 'DECLARIS', vm.declaration.codeSecurite, function (value) {
                    vm.formHelper.authorized = value;
                    vm.formHelper.showValidationMsg = !vm.formHelper.authorized;
                }, function (error) {
                    $log.error('Erreur appel ws /whitelist/check');
                    vm.treatError(error);
                });
            }
        };

        vm.getDateDebut = function () {
            if (vm.declaration && vm.declaration.anneeFiscale) {
                return vm.declaration.anneeFiscale + '-01-01';
            }
            return (new Date().getFullYear() - 1) + '-01-01';
        };

        vm.getDateFin = function () {
            if (vm.declaration && vm.declaration.anneeFiscale) {
                return vm.declaration.anneeFiscale + '-12-31';
            }
            return (new Date().getFullYear() - 1) + '-12-31';
        };

        vm.getLanguage = function() {
            return Language.current();
        };

        // L'année est surchargée, seuls les mois et jours sont conservés.
        var oriLR = {index: 1, pisInconnue: false, sexe: 'M', nbEnfants: 0, periodeDu: vm.getDateDebut(), periodeAu: vm.getDateFin(),
            tauxActivite: 1, tauxAutresActivites: 0, travailDiscontinu: false, nbHeuresTravail: null,tauxTeletravailFrance: null,
            paysResidence: null};

        vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];

        var oriDeclaration = angular.copy(vm.declaration);

        var resetPeriod = function() {
            angular.forEach(vm.declaration.listesRecapitulatives, function (value) {
                value.periodeDu = vm.getDateDebut();
                value.periodeAu = vm.getDateFin();
            });
            oriLR.periodeDu = vm.getDateDebut();
            oriLR.periodeAu = vm.getDateFin();
        };

        function preventDefault(e) {
            e.preventDefault();
        }

        var init = function () {
            if (vm.formHelper.saved != null) {
                vm.declaration = JSON.parse(vm.formHelper.saved);
                vm.declaration.revenuTotal = null;
                vm.declaration.revenuDeterminantTotal = null;
                vm.declaration.retenueTotal = null;
                vm.declaration.commission = null;
                vm.declaration.retenueNette = null;
                vm.declaration.remarque = null;
                vm.declaration.excelFile = null;
                vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];
                vm.declaration.typeDeclarationIs = 'FORM';
                vm.checkAuthorization();
                vm.formHelper.saveHeader = true;
            }

            if ($stateParams.locale) {
                vm.declaration.langue = $stateParams.locale;
                $translate.use($stateParams.locale);
            } else {
                $translate.use('fr');
            }

            LocaliteService.getByCanton(cantonFRCode).then(function (response) {
                vm.localites = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /localite/canton');
                vm.treatError(error);
            });

            ContextFiscalService.getAnneesFiscales().then(function (response) {
                vm.formHelper.anneesFiscales = response.data;
                var lastYear = new Date().getFullYear() - 1;
                var defaultAnneeFiscale = -1;
                angular.forEach(vm.formHelper.anneesFiscales, function (val) {
                    if (val === lastYear) {
                        defaultAnneeFiscale = val;
                        return;
                    }
                });
                if(!vm.declaration.anneeFiscale) {
                    vm.declaration.anneeFiscale = defaultAnneeFiscale;
                }
                vm.anneeFiscaleSelected();
                oriDeclaration.anneeFiscale = vm.declaration.anneeFiscale;
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                vm.treatError(error);
            });

            $scope.$on('cfpLoadingBar:started', function () {
                $window.addEventListener('keydown', preventDefault);
            });

            $scope.$on('cfpLoadingBar:completed', function () {
                $window.removeEventListener('keydown', preventDefault);
                vm.sendHeightToParent();
            });
            $scope.loadCountries();
        }

        $scope.normaliserTauxTeletravail = function (listeRecapitulative) {
            var t = listeRecapitulative.tauxTeletravailFrance;

            if (t == null || t === '') {
                return;
            }

            t = Number(t);
            if (isNaN(t)) {
                listeRecapitulative.tauxTeletravailFrance = null;
                return;
            }

            if (t < 0) {
                t = 0;
            }
            if (t > 100) {
                t = 100;
            }

            listeRecapitulative.tauxTeletravailFrance = t;
        };


        $scope.loadCountries = function () {

            // Déterminer la langue de l'utilisateur : on force à 'fr' ou 'de'
            var userLang = $translate.use() === 'de' ? 'de' : 'fr';

            // Construire l'URL du fichier JSON statique
            var url = 'content/countries-' + userLang + '.json';

            $http.get(url)
                .then(function (response) {

                    $scope.countryList = [
                        { code: 'FR', name: 'FRANCE' }
                    ];
                })
                .catch(function (error) {
                    // Journaliser l'erreur mais ne pas bloquer le formulaire
                    $log.error('Erreur lors du chargement de la liste des pays : ', error);
                    $scope.countryList = [];
                });
        };


        vm.sanitizeTauxTeletravail = function (lr) {
            // Ne rien faire si le modèle est vide
            if (lr.tauxTeletravailFrance === null || lr.tauxTeletravailFrance === undefined || lr.tauxTeletravailFrance === '') {
                return;
            }

            // Forcer un nombre entier
            var value = parseInt(lr.tauxTeletravailFrance, 10);

            // Si ce n’est pas un nombre, on remet à null
            if (isNaN(value)) {
                lr.tauxTeletravailFrance = null;
                return;
            }

            // Bornes 0–100
            if (value < 0) {
                value = 0;
            } else if (value > 100) {
                value = 100;
            }

            lr.tauxTeletravailFrance = value;
        };


        $scope.$on('$translateChangeSuccess', function () {
            $scope.loadCountries();
        });


        // synchroniser le pays de résidence avec le taux de télétravail
        $scope.syncPaysResidenceFromTeletravail = function (lr) {
            // Vérifier la présence + conversion numérique
            var v = lr && lr.tauxTeletravailFrance;

            // Si vide => on nettoie le pays (optionnel)
            if (v === null || v === undefined || v === '') {
                lr.paysResidence = null;
                return;
            }

            // Conversion en nombre (gère "10", "10.5", "10,5")
            var n = Number(String(v).replace(',', '.'));

            // Si valide (0..100) => France
            if (!isNaN(n) && n >= 0 && n <= 100) {
                lr.paysResidence = 'FR';
            } else {
                // Si invalide => on nettoie (optionnel)
                lr.paysResidence = null;
            }
        };




        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('declaris-form-content-wrapper');
        }

        init();

        vm.anneeFiscaleSelected = function () {
            if (vm.declaration.anneeFiscale) {
                BaremeService.getCodeLRByAnnFis(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremes = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale, +'/lr');
                    vm.treatError(error);
                });

                BaremeService.getCodeSansRevenuDeterminantByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesSansRevenuDeterminant = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/sansrevenudeterminant');
                    vm.treatError(error);
                });

                BaremeService.getCodeEnfantObligatoireByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesEnfantObligatoire = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/enfantobligatoire');
                    vm.treatError(error);
                });

                BaremeService.getCodeAvecEnfantsByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesAvecEnfants = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/avecenfants');
                    vm.treatError(error);
                });

                ContextFiscalService.getByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.formHelper.contexteFiscale = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /contextefiscal');
                    vm.treatError(error);
                });
                vm.declaration.periodeDebut = vm.declaration.anneeFiscale + '-01-01';
                vm.declaration.periodeFin = vm.declaration.anneeFiscale + '-12-31';

                resetPeriod();

                vm.checkAuthorization();
            }
        };

        vm.addEntry = function () {
            var lastEntry = vm.declaration.listesRecapitulatives[vm.declaration.listesRecapitulatives.length - 1];

            var newIndex = lastEntry.index + 1;

            var newEntry = angular.copy(oriLR);
            newEntry['index'] = newIndex;

            vm.declaration.listesRecapitulatives.push(newEntry);
            vm.calculateTotals();
            vm.$broadcast('show-errors-reset');
            vm.sendHeightToParent();
        };

        vm.removeEntry = function (index) {

            var indexKey = null;

            angular.forEach(vm.declaration.listesRecapitulatives, function (value, key) {
                if (value.index === index) {
                    indexKey = key;
                    return;
                }
            });

            vm.declaration.listesRecapitulatives.splice(indexKey, 1);
            vm.calculateTotals();
            vm.sendHeightToParent();
        };

        vm.goToFirstStep = function () {
            vm.formHelper.step = 1;
            vm.formHelper.errorMsg = null;
            vm.formHelper.showValidationMsg = false;
            vm.errors = {};
            vm.warnings = {};
        };

        var filterErrors = function(errors) {
            vm.errors = {};
            angular.forEach(errors, function (value) {
                if (value.index > 0) {
                    vm.errors[value.index + value.field] = value;
                }
            });
        };

        var filterWarnings = function(warnings) {
            vm.warnings = {};
            angular.forEach(warnings, function (value) {
                if (value.index > 0) {
                    vm.warnings[value.index + value.field] = value;
                }
            });
        };

        vm.treatError = function(error, frontend) {
            vm.formHelper.errorMsg = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);

            ErrorUtil.treatError(error, frontend, function() {
                FrontendlogService.logWhitelist(vm.declaration.ndc, vm.declaration.anneeFiscale, vm.declaration.codeSecurite, error, function (value) {
                    // We don't care, it's logging
                }, function (err) {
                    // We don't care, it's logging
                });
            });
        };

        vm.goToSecondStep = function () {
            try {
                if (vm.formHelper.saveHeader) {
                    $window.localStorage.setItem(localStorageKey, JSON.stringify(vm.declaration));
                } else {
                    $window.localStorage.removeItem(localStorageKey);
                }

                vm.$broadcast('show-errors-check-validity');
                if (vm.isFormValid()) {
                    var stopWatching = vm.$watch(function (){return vm.ongoingRequest;},function(newVal) {
                        if(newVal === false) {
                            stopWatching();
                            DeclarationLRService.check(vm.declaration, vm.declaration.excelFile).then(function (response) {
                                var value = response.data;
                                var excelFile = vm.declaration.excelFile;
                                vm.declaration = value.declarationLRDTO;
                                vm.declaration.excelFile = excelFile;
                                filterErrors(value.errors);
                                filterWarnings(value.warnings);
                                vm.formHelper.step = 2;
                            }).catch(function (error) {
                                $log.error('Erreur appel ws /declaration/lr/check');
                                vm.treatError(error);
                            });
                        }
                    });
                }
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.getRemarqueScc = function () {
            return vm.declaration.remarqueScc.split('\n').join('<br>');
        };

        vm.getRemarqueSccLines = function () {
            if (vm.declaration && vm.declaration.remarqueScc) {
                return vm.declaration.remarqueScc.split('\n');
            }
            return "";
        };

        $scope.verifierTeletravailFrance = function(lr) {
            if (lr.tauxTeletravailFrance < 0) lr.tauxTeletravailFrance = 0;
            if (lr.tauxTeletravailFrance > 100) lr.tauxTeletravailFrance = 100;
        };

        vm.sendDeclaration = function () {
            try {
                DeclarationLRService.create(vm.declaration, vm.declaration.excelFile).then(function () {
                    vm.formHelper.step = 3;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr');
                    vm.treatError(error);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.uploadExcelFile = function () {
            try {
                DeclarationLRService.check(vm.declaration, vm.declaration.excelFile).then(function (response) {
                    var value = response.data;
                    var tmpExcelFile = vm.declaration.excelFile;
                    vm.declaration = value.declarationLRDTO;
                    vm.declaration.excelFile = tmpExcelFile;
                    filterErrors(value.errors);
                    filterWarnings(value.warnings);
                    vm.formHelper.fileUploaded = true;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr/check');
                    $log.error(error);
                    vm.formHelper.fileUploadError = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.loadExcelFile = function () {
            var excelInput = document.getElementById('excel');
            var excelFile = excelInput.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                vm.uploadExcelFile();
            };
            reader.readAsDataURL(excelFile);
        };

        vm.resetInputFile = function () {
            var excelInput = document.getElementById('excel');
            if (excelInput) {
                excelInput.value = '';
            }
            vm.formHelper.fileUploaded = false;
            vm.formHelper.fileUploadError = null;
            vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];
        };

        vm.calculer = function (listeRecapitulative) {
            if (this.isBaremeEnfantObligatoire(listeRecapitulative.bareme) && listeRecapitulative.nbEnfants < 1) {
                listeRecapitulative.nbEnfants = 1;
            }
            if (this.isBaremeSansRevenuDeterminant(listeRecapitulative.bareme) || !this.isBaremeAvecEnfants(listeRecapitulative.bareme)) {
                listeRecapitulative.nbEnfants = 0;
            }
            if (listeRecapitulative.bareme && listeRecapitulative.revenu > 0 && listeRecapitulative.periodeDu && listeRecapitulative.periodeAu) {
                vm.ongoingRequest = true;
                BaremeService.calculerCote(vm.formHelper.contexteFiscale,
                                            listeRecapitulative.periodeDu, listeRecapitulative.periodeAu, listeRecapitulative.bareme,
                                            listeRecapitulative.nbEnfants, listeRecapitulative.revenu, listeRecapitulative.travailDiscontinu,
                                            listeRecapitulative.tauxActivite, listeRecapitulative.tauxAutresActivites, listeRecapitulative.nbHeuresTravail,
                                            listeRecapitulative.revenuDeterminant)
                    .then(function (response) {
                        vm.ongoingRequest = false;
                        var value = response.data;
                        listeRecapitulative.retenue = value.retenue;
                        listeRecapitulative.computedRetenue = value.retenue;
                        listeRecapitulative.revenuDeterminant = value.revenuDeterminant;
                        listeRecapitulative.computedRevenuDeterminant = value.revenuDeterminantCalcule;
                        vm.calculateTotals();
                    }).catch(function (error) {
                        vm.ongoingRequest = false;
                        $log.error('Erreur appel ws /bareme/cote');
                        vm.treatError(error);
                    });
            } else {
                listeRecapitulative.retenue = null;
                listeRecapitulative.computedRetenue = null;
                listeRecapitulative.revenuDeterminant = null;
                listeRecapitulative.computedRevenuDeterminant = null;
            }
            vm.calculateTotals();
        };

        vm.resetRevenuDeterminantEtCalculer = function (listeRecapitulative) {
            listeRecapitulative.revenuDeterminant = null;
            listeRecapitulative.computedRevenuDeterminant = null;
            vm.calculer(listeRecapitulative);
        }

        vm.calculateTotals = function () {
            vm.declaration.revenuTotal = Number(0.0);
            vm.declaration.revenuDeterminantTotal = Number(0.0);
            vm.declaration.retenueTotal = Number(0.0);

            angular.forEach(vm.declaration.listesRecapitulatives, function (value) {
                if (!isNaN(value.revenu)) {
                    vm.declaration.revenuTotal += Number(value.revenu);
                }
                if (!isNaN(value.retenue)) {
                    vm.declaration.retenueTotal += Number(value.retenue);
                }
                if (!isNaN(value.revenuDeterminant)) {
                    vm.declaration.revenuDeterminantTotal += Number(value.revenuDeterminant);
                }
            });

            vm.declaration.commission = Math.round(vm.declaration.retenueTotal * vm.formHelper.contexteFiscale.tauxCommission * 20) / 20;
            vm.declaration.retenueNette = vm.declaration.retenueTotal - vm.declaration.commission;
        };

        vm.hasErrors = function (listeRecapitulative, fields) {
            var errorMessage = ValidationUtil.getValidationMessage(vm.errors, listeRecapitulative, fields);
            return !angular.isUndefined(errorMessage) && errorMessage !== null;
        };

        vm.hasWarnings = function (listeRecapitulative, fields) {
            if (vm.hasErrors(listeRecapitulative, fields)) {
                // Les erreurs sont prioritaires par rapport aux warning
                return false;
            }
            var warningMessage = ValidationUtil.getValidationMessage(vm.warnings, listeRecapitulative, fields);
            return !angular.isUndefined(warningMessage) && warningMessage !== null;
        };

        var trusted = {}
        vm.getValidationMessage = function (listeRecapitulative, fields) {
            var html = ValidationUtil.getValidationMessage(vm.errors, listeRecapitulative, fields);
            if (angular.isUndefined(html) || html === null) {
                html = ValidationUtil.getValidationMessage(vm.warnings, listeRecapitulative, fields);
            }
            // Caching nécessaire à cause du problème https://github.com/angular/angular.js/issues/3932
            return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
        };

        vm.showAuthorizationResult = function () {
            if (vm.declaration.ndc && vm.declaration.ndc !== '' && vm.declaration.codeSecurite && vm.declaration.codeSecurite !== '') {
                return !vm.formHelper.authorized;
            }
            return false;
        };

        var hasValidationErrors = function() {
            return ObjectUtils.isNonEmptyObject(vm.errors) || vm.formHelper.fileUploadError;
        };

        vm.isFormValid = function () {
            var lrFormValid = true;
            if (this.declarationIsForm) {
                lrFormValid = vm.declaration.typeDeclarationIs === 'FORM' && !this.declarationIsForm.$invalid;
            }

            var headerFormValid = true;
            if (this.declarationHeaderForm) {
                headerFormValid = !this.declarationHeaderForm.$invalid;
            }

            var excelFormValid = vm.declaration.typeDeclarationIs === 'EXCEL'
                    && vm.declaration.excelFile !== undefined && vm.declaration.excelFile !== null;

            var formValid = headerFormValid && (lrFormValid || excelFormValid);

            var valid = formValid && !hasValidationErrors() && vm.formHelper.authorized;

            if (valid) {
                vm.formHelper.showValidationMsg = false;
            }

            return valid;
        };

        vm.retenueModified = function (listeRecapitulative) {
            if (!listeRecapitulative.retenue || listeRecapitulative.retenue <= 0) {
                vm.calculer(listeRecapitulative);
            }
            vm.calculateTotals();
        };

        vm.isRetenueModified = function (listeRecapitulative) {
            if (!listeRecapitulative.retenue && !listeRecapitulative.computedRetenue) {
                return false;
            }
            return listeRecapitulative.retenue && listeRecapitulative.computedRetenue && listeRecapitulative.retenue !== listeRecapitulative.computedRetenue;
        };

        vm.isRevenuDeterminantModified = function (listeRecapitulative) {
            if (!listeRecapitulative.revenuDeterminant || !listeRecapitulative.computedRevenuDeterminant) {
                return false;
            }
            return listeRecapitulative.revenuDeterminant !== listeRecapitulative.computedRevenuDeterminant;
        };

        vm.resetForm = function () {
            vm.formHelper.fileUploadError = null;
            vm.declaration = oriDeclaration;
            vm.resetInputFile(document.getElementById('excel'));
            vm.$broadcast('show-errors-reset');
            vm.formHelper.showValidationMsg = false;
            vm.formHelper.errorMsg = null;
        };

        vm.printDiv = function() {
            try {
                DeclarationLRService.download(vm.declaration, vm.declaration.excelFile).then(function (response) {
                    var file = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    var fileURL = URL.createObjectURL(file);
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'download.pdf';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr/download');
                    vm.treatError(error);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.showValidation = function() {
            vm.formHelper.showValidationMsg = true;
            vm.$broadcast('show-errors-check-validity');
        };

        vm.customInputChange = function(lr) {
            vm.calculer(lr);
            $timeout(function() {
                vm.showValidation();
            }, 500);
        };

        vm.localiteSelected = function(lr, localite) {
            lr.npa = localite.npa;
            lr.localite = localite.nom;
        }

        vm.updateValidation = function () {
            // Obligatoire pour palier à un bug dans ui-select en combinaison avec show-errors
            vm.$broadcast('show-errors-check-validity');
        };

        vm.isBaremeSansRevenuDeterminant = function (bareme) {
            return ListUtils.isStringInList(vm.baremesSansRevenuDeterminant, bareme)
        };

        vm.isBaremeEnfantObligatoire = function (bareme) {
            return ListUtils.isStringInList(vm.baremesEnfantObligatoire, bareme)
        };

        vm.isBaremeAvecEnfants = function (bareme) {
            return ListUtils.isStringInList(vm.baremesAvecEnfants, bareme)
        };

        vm.activiteChange = function(lr) {
            lr.nbHeuresTravail = null;
            lr.tauxActivite = null;
            lr.tauxAutresActivites = null;
            if(lr.travailDiscontinu) {
                lr.nbHeuresTravail = 1;
            } else {
                lr.tauxActivite = 1;
                lr.tauxAutresActivites = 0;
            }
            vm.calculer(lr);
        }

        vm.isBaremeAAvecEnfant = function (lr) {
            return lr.bareme === 'A' && lr.nbEnfants > 0;
        }

    });
